export const SpaceListSearch = [
  {
    id: '北京数据中心',
    label: '北京数据中心',
    isSelect: false,
    type: '省市',
    spaceLevel: '北京',
    scaneName: '北京',
    highLight: '北京',
    num: 2,
    objType: 'space',
    components: 'ShuJuZhongXingSheng',
    level: '2',
    children: [
      {
        id: '分数据中心-01',
        label: '分数据中心-01',
        isSelect: false,
        type: '园区',
        spaceLevel: '园区',
        scaneName: '园区',
        highLight: '园区',
        num: 1,
        objType: 'space',
        components: 'ShuJuZhongXingYuanQu',
        level: '3',
        children: [
          {
            id: 'SM_IDC机房楼',
            label: 'IDC机房楼',
            isSelect: false,
            type: '建筑',
            spaceLevel: '',
            scaneName: '园区',
            num: 3,
            objType: 'space',
            components: 'JianZhu',
            level: '4',
            children: [
              {
                id: 'SM_IDC室内04',
                label: 'F3',
                isSelect: false,
                type: '楼层',
                spaceLevel: '楼层',
                scaneName: '园区',
                highLight: '楼层',
                num: 3,
                objType: 'space',
                components: 'LouCeng',
                level: '5',
                children: [
                  {
                    id: '机柜组机房',
                    label: '机柜组机房',
                    isSelect: false,
                    type: '房间',
                    spaceLevel: '房间',
                    highLight: '机柜组机房',
                    scaneName: '园区',
                    num: 23,
                    objType: 'space',
                    components: 'FangJian',
                    level: '6',
                    children: [
                      {
                        id: 'C03-004_SM_机柜组',
                        label: 'C03-004_SM_机柜组',
                        isSelect: false,
                        type: '机柜组',
                        highLight: '机柜组',
                        spaceLevel: '机柜',
                        scaneName: '园区',
                        num: 1,
                        objType: 'space',
                        components: 'JiGuiZaixian',
                        level: '7',
                        children: [
                          {
                            id: 'C03-004-04_SM_设备机柜',
                            label: 'C03-004-04_SM_设备机柜',
                            isSelect: false,
                            type: '机柜',
                            spaceLevel: 'spaceL7',
                            scaneName: '园区',
                            highLight: 'C03-004-04_SM_设备机柜',
                            num: 7,
                            objType: 'space',
                            components: 'JiGuiLixian',
                            level: '8',
                            children: [
                              {
                                id: 'C03-004-04_SM_配线架',
                                label: 'C03-004_配线架',
                                isSelect: false,
                                type: '设备',
                                spaceLevel: '设备',
                                scaneName: '园区',
                                highLight: '设备',
                                num: 0,
                                objType: 'space',
                                components: 'JiQi',
                                level: '9',
                              },
                              {
                                id: 'C03-004-04_SM_交换机',
                                label: 'C03-004_交换机',
                                isSelect: false,
                                type: '设备',
                                spaceLevel: '设备',
                                scaneName: '园区',
                                highLight: '设备',
                                num: 0,
                                objType: 'space',
                                components: 'JiaoHuanJi',
                                level: '9',
                              },
                              {
                                id: 'C03-004-04_SM_数据服务器_虚拟机',
                                label: 'C03-004_数据服务器_虚拟机',
                                isSelect: false,
                                type: '设备',
                                spaceLevel: '设备',
                                scaneName: '园区',
                                highLight: '设备',
                                num: 0,
                                objType: 'space',
                                components: 'FuWuQiXuNiJi',
                                level: '9',
                              },
                              {
                                id: 'C03-004-04_SM_路由器',
                                label: 'C03-004_路由器',
                                isSelect: false,
                                type: '设备',
                                spaceLevel: '设备',
                                scaneName: '园区',
                                highLight: '设备',
                                num: 0,
                                objType: 'space',
                                components: 'LuYouQi',
                                level: '9',
                              },
                              {
                                id: 'C03-004-04_SM_服务器',
                                label: 'C03-004_服务器',
                                isSelect: false,
                                type: '设备',
                                spaceLevel: '设备',
                                scaneName: '园区',
                                highLight: '设备',
                                num: 0,
                                objType: 'space',
                                components: 'FuWuQiBiaoZhun',
                                level: '9',
                              },
                              {
                                id: 'C03-004-04_SM_网络存储服务器',
                                label: 'C03-004_网络存储服务器',
                                isSelect: false,
                                type: '设备',
                                spaceLevel: '设备',
                                scaneName: '园区',
                                highLight: '设备',
                                num: 0,
                                objType: 'space',
                                components: 'JiQi',
                                level: '9',
                              },
                              {
                                id: 'C03-004-04_SM_GPU服务器',
                                label: 'C03-004_GPU服务器',
                                isSelect: false,
                                type: '设备',
                                spaceLevel: '设备',
                                scaneName: '园区',
                                highLight: '设备',
                                num: 0,
                                objType: 'space',
                                components: 'JiQi',
                                level: '9',
                              },
                            ],
                          },
                        ],
                      },
                      {
                        id: 'A01-004_SM_机柜组',
                        label: 'A01-004_SM_机柜组',
                        isSelect: false,
                        type: '机柜组',
                        highLight: '机柜组',
                        spaceLevel: '机柜',
                        scaneName: '园区',
                        num: 1,
                        objType: 'space',
                        components: 'JiGuiZaixian',
                        level: '7',
                        children: [
                          {
                            id: 'A01-04_SM_设备机柜',
                            label: 'A01-04_SM_设备机柜',
                            highLight: 'A01-004-04_SM_机柜组',
                            isSelect: false,
                            type: '机柜',
                            spaceLevel: 'spaceL7',
                            scaneName: '园区',
                            num: 0,
                            objType: 'space',
                            components: 'JiGuiLixian',
                            level: '8',
                            children: [
                              {
                                id: 'A01-004-04_SM_配线架',
                                label: 'A01-004_配线架',
                                isSelect: false,
                                type: '设备',
                                spaceLevel: '设备',
                                scaneName: '园区',
                                highLight: '设备',
                                num: 0,
                                objType: 'space',
                                components: 'JiQi',
                                level: '9',
                              },
                              {
                                id: 'A01-004-04_SM_服务器',
                                label: 'A01-004_服务器',
                                isSelect: false,
                                type: '设备',
                                spaceLevel: '设备',
                                scaneName: '园区',
                                highLight: '设备',
                                num: 0,
                                objType: 'space',
                                components: 'JiQi',
                                level: '9',
                              },
                            ],
                          },
                        ],
                      },
                      {
                        id: 'F06-004_SM_机柜组',
                        label: 'F06-004_SM_机柜组',
                        isSelect: false,
                        type: '机柜组',
                        highLight: '机柜组',
                        spaceLevel: '机柜',
                        scaneName: '园区',
                        num: 1,
                        objType: 'space',
                        components: 'JiGuiZaixian',
                        level: '7',
                        children: [
                          {
                            id: 'F06-004-07_SM_设备机柜',
                            label: 'F06-004-07_SM_设备机柜',
                            highLight: 'F06-004-07_SM_设备机柜',
                            isSelect: false,
                            type: '机柜',
                            spaceLevel: 'spaceL7',
                            scaneName: '园区',
                            num: 0,
                            objType: 'space',
                            components: 'JiGuiZaixian',
                            level: '8',
                            children: [
                              {
                                id: 'F06-004-04_SM_配线架',
                                label: 'F06-004_配线架',
                                isSelect: false,
                                type: '设备',
                                spaceLevel: '设备',
                                scaneName: '园区',
                                highLight: '设备',
                                num: 0,
                                objType: 'space',
                                components: 'JiQi',
                                level: '9',
                              },
                              {
                                id: 'F06-004-04_SM_大型服务器',
                                label: 'F06-004_大型服务器',
                                isSelect: false,
                                type: '设备',
                                spaceLevel: '设备',
                                scaneName: '园区',
                                highLight: '设备',
                                num: 0,
                                objType: 'space',
                                components: 'JiQi',
                                level: '9',
                              },
                            ],
                          },
                        ],
                      }
                    ],
                  },
                ],
              },
            ],
          },
        ],
      },
    ],
  },
]